import { Entry } from '../Entry'

export function Entry20220331() {
  return (
    <Entry title="31/03/2022 - v3.0.0-beta-18">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12454/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
